import { Person } from '@mui/icons-material';
import { Box, Stack, Tooltip } from '@mui/material';
import { TableTemplateCell } from '/@/components/bayer/table/template-cell';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import type { useInvitationByUser } from '/@/hooks/nodes';
import { _ } from '/@/locale';

const GrowerNameCell = ({
    name,
    location,
    hasAssignedUser,
    invitationStatus,
}: {
    name: string;
    location?: string;
    hasAssignedUser?: boolean;
    invitationStatus?: ReturnType<typeof useInvitationByUser>['invitationStatus'];
}) => {
    return (
        <Stack direction='row' spacing={1} alignItems='center'>
            <TableTemplateCell title={name} subtitle={location} />
            {hasAssignedUser && (
                <Tooltip title={_('Tiene cuenta en {{appName}}', { appName: settings.app.name })}>
                    <Person width='18px' height='18px' />
                </Tooltip>
            )}
            {invitationStatus === 'connected' && (
                <Box width='18px' height='18px'>
                    <Icon type='fieldview' style={{ fill: '#F7B618', width: '18px', height: '18px' }} />
                </Box>
            )}
        </Stack>
    );
};

export default GrowerNameCell;
